import { Component, computed, ElementRef, inject, input, viewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { UsersImporterFacade } from '@app/store/users-importer';

@Component({
    selector: 'app-import-learners',
    templateUrl: './import-learners.component.html',
    styleUrls: ['./import-learners.component.css'],
    imports: [TranslateModule, ButtonModule],
})
export class ImportLearnersComponent {
    private readonly usersImporterFacade = inject(UsersImporterFacade);

    readonly schoolId = input.required<string>();

    readonly fileInput = viewChild.required<ElementRef<HTMLInputElement>>('fileInput');

    readonly importing = this.usersImporterFacade.importing;
    readonly downloadingTemplate = this.usersImporterFacade.downloadingTemplate;
    readonly summary = this.usersImporterFacade.summary;

    readonly issues = computed(() => {
        const summary = this.summary();
        if (!summary) {
            return [];
        }
        return summary.results.filter((result) => result.status !== 'created');
    });

    onImportClick(): void {
        this.fileInput().nativeElement.click();
    }

    onFileSelected(event: Event): void {
        const input = <HTMLInputElement>event.target;
        const file = input.files?.[0];
        if (file) {
            this.usersImporterFacade.importLearners(this.schoolId(), file);
        }
        input.value = '';
    }

    onDownloadTemplate(): void {
        this.usersImporterFacade.downloadTemplate();
    }

    onClearSummary(): void {
        this.usersImporterFacade.clearSummary();
    }
}
